import { RobotAngryOutlineIcon } from './RobotAngryOutlineIcon';

/**
 * author: Colton Wiscombe
 * id D922E043-E4B6-4FAA-9717-51C1935DD20A
 * name robot-angry-outline
 * version: 5.8.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/robot-angry-outline.svg
 * tags
 */
export const EmojiRobotAngryOutlineIcon = RobotAngryOutlineIcon;
export default EmojiRobotAngryOutlineIcon